import axios from 'axios';
import { useContext, useEffect, useMemo, useState } from 'react';
import { MdAssignment } from 'react-icons/md';
import { AppContext } from '../../AppProvider';

export default function ContinentSelector() {
  const [rawData, setRawData] = useState([]);
  const { uri } = useContext(AppContext);

  useEffect(() => {
    axios.get(`${uri}work-locations/`)
      .then(response => {
        setRawData(response.data);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, [uri]);

  const countryData = useMemo(() => {
    const dataMap = rawData.reduce((acc, item) => {
      if (!acc[item.subcontinent]) acc[item.subcontinent] = {};
      if (!acc[item.subcontinent][item.country]) acc[item.subcontinent][item.country] = [];
      acc[item.subcontinent][item.country].push(item);
      return acc;
    }, {});

    Object.keys(dataMap).forEach(subcontinent => {
      const sortedCountries = Object.keys(dataMap[subcontinent]).sort();
      const sortedData = {};
      for (const country of sortedCountries) {
        sortedData[country] = dataMap[subcontinent][country];
      }
      dataMap[subcontinent] = sortedData;
    });

    return dataMap;
  }, [rawData]);

  const continents = Object.keys(countryData);
  const [selectedContinent, setSelectedContinent] = useState(continents[0] || "");

  useEffect(() => {
    if (continents.length > 0 && !selectedContinent) {
      setSelectedContinent(continents[0]);
    }
  }, [continents, selectedContinent]);

  const handleContinentClick = (continent) => {
    setSelectedContinent(continent);
  };

  return (
    <div className="bg-base_900 bg-opacity-10 px-4 sm:px-6 md:px-10 lg:px-20 py-6">
      <div className="flex flex-wrap gap-2 justify-start mb-6">
  {continents.sort().map((continent) => (
    <button
      key={continent}
      className={`py-2 px-5 text-base font-semibold rounded-full border transition-all duration-200
        ${selectedContinent === continent
          ? 'bg-blue-500 text-white border-blue-500'
          : 'bg-white text-gray-700 border-gray-300 hover:bg-blue-100'}
      `}
      onClick={() => handleContinentClick(continent)}
    >
      {continent}
    </button>
  ))}
</div>


      {selectedContinent && countryData[selectedContinent] && (
        <div>
          <h3 className="font-bold text-xl text-center border-b border-gray-400 pb-2 mb-4">
            Consultancy Work in {selectedContinent}:
          </h3>

          <div className="grid grid-cols-1 gap-6">
            {Object.keys(countryData[selectedContinent])
              .sort()
              .map((country, idx) => (
                <div key={idx} className="bg-white rounded-lg shadow-md p-6 flex flex-col space-y-4">
                  <div className="flex items-center gap-3">
                    <img
                      src={countryData[selectedContinent][country][0].country_flag}
                      alt={country}
                      className="w-12 h-8 object-cover rounded-sm"
                    />
                    <h4 className="text-xl font-semibold">{country}</h4>
                  </div>

                  {countryData[selectedContinent][country].map((item, index) => (
                    <div key={index} className="space-y-3">
                      <div className="flex items-start text-base text-gray-800 border-b pb-1">
                        <span className="mt-1 mr-2 text-blue-600 "><MdAssignment /></span>
                        <div dangerouslySetInnerHTML={{ __html: item.work_description }} className=''/>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 justify-items-center">
                       {item.image1 ? <div className="relative w-2/3 rounded-lg overflow-hidden shadow">
                          <img
                            src={item.image1}
                            alt="Work Image 1"
                            className="absolute top-0 left-0 w-full h-full object-cover"
                          />
                        </div> :null} 
                       {
                         item.image2 ? <div className="relative w-2/3 pt-[40%] rounded-lg overflow-hidden shadow flex justify-center items-center">
                         <img
                           src={item.image2}
                           alt="Work Image 2"
                           className="absolute top-0 left-0 w-full h-full object-cover"
                         />
                       </div>
                       :null}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}